import styled from 'styled-components'
import LookingTogether from 'assets/images/looking-together.svg?react'

export const EOBNotRequested = () => {
  return (
    <Div>
      <LookingTogether />
      <h1>EOB has not been requested</h1>
      {/* <p>Access the Deploy AI Agent menu to request claim status and EOB</p> */}
    </Div>
  )
}

const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  flex-direction: column;
  margin-top: 3rem;
  gap: 0.5rem;

  svg{
    width: 116px;
    height: 86px;
  }

  h1 {
    ${({ theme }) => theme.typography.m.medium};
    color: ${({ theme }) => theme.colors.primary.darker};
  }
  p {
    ${({ theme }) => theme.typography.s.normal};
    color: ${({ theme }) => theme.colors.neutral.neutral};
  }
`
